import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import { FiMoon, FiSun } from "react-icons/fi";
import { screenButtons } from "./ctiData";
import { getScreenButtonClass } from "./ctiHelpers";
import { useCallStore } from "../../router/zustand/callStore";

const SCREEN_LABEL_MAP = {
  idle: "Dialer Status - Idle",
  ringing: "Ringing",
  oncall: "On Call",
  conference: "Conference",
  disposition: "Disposition",
};

function NavBar({
  screen,
  onScreenChange,
  statusMeta,
  theme,
  onToggleTheme,
  userData,
  showDispositionTab = false,
}) {
  const profiles = userData?.agentData?.agentTelephony?.profile || [];

  const activeTelephonyProfile = useMemo(
    () =>
      profiles.find(
        (p) =>
          (p.type === "WEBRTC" || p.type === "Soft Phone") &&
          p.active_profile === true,
      ),
    [profiles],
  );

  const extension =
    activeTelephonyProfile?.number?.number ||
    profiles.find((p) => p.type === "WEBRTC")?.number?.number ||
    profiles.find((p) => p.type === "Soft Phone")?.number?.number;
  
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const status = sessionStorage.getItem("webrtcPhoneStatus");
  //     setWebrtcStatus(status);
  //   }, 1000);
  
  //   return () => clearInterval(interval);
  // }, []);

  const webrtcStatus = useCallStore((state) => state.webrtcPhoneStatus);
  const parsedStatus = useMemo(() => {
    if (!webrtcStatus) {
      return {
        success: false,
        code: "DISCONNECTED",
        message: "Dialer is Disconnected",
      };
    }
    
    const status = webrtcStatus.toLowerCase();
    
    // ✅ SUCCESS CASE (only 200 / connected)
    if (status === "connected") {
      return {
        success: true,
        code: "READY",
        message: "Dialer connected",
      };
    }
    
    // ✅ AUTHENTICATING (401 first case)
    if (status.includes("authenticating")) {
      return {
        success: false,
        code: "AUTH",
        message: "Authenticating...",
      };
    }
    
    // ✅ GENERIC "code - message" fallback
    const match = webrtcStatus.match(/^(\d+)\s*-\s*(.*)$/);
    
    if (match) {
      return {
        success: false,
        code: match[1],
        message: match[2],
      };
    }
    
    // ✅ FALLBACK (plain message)
    return {
      success: false,
      code: "ERROR",
      message: webrtcStatus,
    };
  }, [webrtcStatus]);

  const dialerReady = Boolean(parsedStatus?.code !== "Ready") && Boolean(parsedStatus?.success);

  const navActions = useMemo(() => {
    let actions = [];
    if (!dialerReady) {
      actions = [{ key: "idle", label: "Dialer Status - Disconnected" }];
    } else if (screen === "oncall") {
      actions = [
        { key: "oncall", label: "On Call" },
        { key: "conference", label: "Conference" },
      ];
    } else if (screen === "conference") {
      actions = [
        { key: "conference", label: "Conference" },
        { key: "oncall", label: "On Call" },
      ];
    } else {
      actions = [{ key: screen, label: SCREEN_LABEL_MAP[screen] || "Idle" }];
    }

    if (showDispositionTab && !actions.some((a) => a.key === "disposition") && dialerReady) {
      actions = [...actions, { key: "disposition", label: "Disposition" }];
    }

    return actions;
  }, [dialerReady, screen, showDispositionTab]);

  return (
    <div className="nav-bar">
      {/* <span className="nav-logo">NEXUS CTI</span> */}
      {/* <div className="agent-badge" style={{ marginRight: "12px" }}>
        <span className="agent-name">{statusText}</span>
      </div> */}

      {navActions.map((btn) => (
        <Button
          key={btn.key}
          className={["screen-btn", getScreenButtonClass(btn.key, screen, parsedStatus)]
            .join(" ")
            .trim()}
          onClick={() => onScreenChange(btn.key)}
        >
          {btn.label}
        </Button>
      ))}
      <div className="spacer" />
      <div className="agent-badge">
        {/* <div className={`agent-dot ${statusMeta.dotClass}`} /> */}
        <button
          type="button"
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
        >
          {theme === "light" ? <FiMoon /> : <FiSun />}
        </button>
        <span className="agent-name">
          {userData?.agentData?.agent_name || "UNKNOWN"}
        </span>
        {extension && (
          <>
            <span className="divider">|</span>
            <span className="agent-ext">Ext. {extension}</span>
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(NavBar);
